module.exports = __webpack_public_path__ + "img/6.31f43dd7.jpg";